export type StartupPosePolicy = "currentScenePose" | "verbatimXmlPose";

export interface PhysicsStartOptions {
  preserveActuatorControls?: boolean;
  startupPosePolicy?: StartupPosePolicy;
  overrideSceneStateForKeyframe?: Record<string, unknown>;
  captureStartSnapshot?: boolean;
}

export type WorkerStartupSeedingStrategy =
  | "seedFromInitQpos"
  | "applyInitialJointMap"
  | "fallbackApplyInitialJoints";

export function normalizeStartupPosePolicy(
  policy: StartupPosePolicy | string | null | undefined
): StartupPosePolicy {
  return policy === "currentScenePose" ? "currentScenePose" : "verbatimXmlPose";
}

export function resolveWorkerStartupSeedingStrategy(input: {
  startupPosePolicy?: StartupPosePolicy | string | null;
  hasInitialJointMap: boolean;
  hasInitQpos: boolean;
}): WorkerStartupSeedingStrategy {
  const policy = normalizeStartupPosePolicy(input.startupPosePolicy);
  if (policy === "currentScenePose") {
    return input.hasInitQpos ? "seedFromInitQpos" : "fallbackApplyInitialJoints";
  }
  if (input.hasInitialJointMap) return "applyInitialJointMap";
  return input.hasInitQpos ? "seedFromInitQpos" : "fallbackApplyInitialJoints";
}

export function getStartupXmlBuildFlags(policy: StartupPosePolicy | string | null | undefined): {
  emitScalarJointRef: boolean;
  seedScalarInitQposFromCurrent: boolean;
} {
  const normalized = normalizeStartupPosePolicy(policy);
  if (normalized === "currentScenePose") {
    return {
      emitScalarJointRef: true,
      seedScalarInitQposFromCurrent: true,
    };
  }
  return {
    emitScalarJointRef: true,
    seedScalarInitQposFromCurrent: false,
  };
}
